import React from "react";
import Datatables from "../../components/Datatables/Table";
import TableCell from "../../components/Datatables/TableCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import SettleExpenseModal from "../../components/Expense/settleModal";
function SummaryTable({ loading, data, handleDelete,setReload,reload }) {
  const [modal, setModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const viewExpenseOnClick = (row) => {
    setSelectedRow(row);
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
    setReload(!reload)
    setSelectedRow(null);
  };
  const dataHeader = [
    {
      key: "receiverId",
      label: "Receiver Id",
    },
    {
      key: "payerId",
      label: "Payer Id",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "action",
      label: "Action",
    },
  ];

  return (
    <Datatables loading={loading} dataHeader={dataHeader}>
      {data?.map((row, index) => (
        <tr
          key={index}
          className="bg-white border md:border-b block md:table-row rounded-md shadow-md md:rounded-none md:shadow-none mb-5"
        >
          <TableCell dataLabel="Reciver Id" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">
              {row.receiverId}
            </p>
          </TableCell>
          <TableCell dataLabel="Payer Id" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.payerId}</p>
          </TableCell>
          <TableCell dataLabel="Amount" showLabel={true}>
            <p className="font-normal text-sm text-gray-500"></p>

            <span className="rounded-full py-1 px-3 text-xs font-semibold bg-gray-200 text-green-900">
              {row.amount}
            </span>
          </TableCell>
          <TableCell>
            {row.payerId==user.email?
              <div className="text-sky-700 inline-flex  rounded text-sm">
              <button
                className="clickme"
                onClick={() => viewExpenseOnClick(row)}
              >
                <FontAwesomeIcon icon={faReceipt} />{" Settle up"}
              </button>
            </div>:null}
          
          </TableCell>
        </tr>
      ))}
      {selectedRow && (
        <SettleExpenseModal
          isOpen={modal}
          setModal={setModal}
          onClose={closeModal}
          expenseData={selectedRow}
        />
      )}
    </Datatables>
  );
}

export default SummaryTable;
